// @flow

import Cookie from 'js-cookie';

const APPLICATION_ID_COOKIE_KEY = 'gpo-application-id';
const APPLICATION_ID_SESSION_KEY = 'gpo-application-id';

export const getApplicationId = () => Cookie.get(APPLICATION_ID_COOKIE_KEY);

export const getSessionApplicationId = () =>
  sessionStorage.getItem(APPLICATION_ID_SESSION_KEY);

export const setApplicationId = (applicationId: string) =>
  Cookie.set(APPLICATION_ID_COOKIE_KEY, applicationId, { expires: 1 });

export const setSessionApplicationId = (applicationId: string) =>
  sessionStorage.setItem(APPLICATION_ID_SESSION_KEY, applicationId);
